import { apiFetch } from "../../api/client";
import type { AddSegmentContactsResult, AdminSegmentSummary, AdminSegmentWriteRequest } from "../../api/types";

/** `GET admin/segments` (role Consulta). */
export function listSegments(): Promise<AdminSegmentSummary[]> {
  return apiFetch<AdminSegmentSummary[]>("/panel/segments");
}

/** `GET admin/segments/{id}` (role Consulta). */
export function getSegment(id: string): Promise<AdminSegmentSummary> {
  return apiFetch<AdminSegmentSummary>(`/panel/segments/${id}`);
}

/**
 * `GET admin/segment-options` (role Consulta) — bounded (`size<=50`) selector read for the
 * campaign editor's segment selector (redesign-panel-hubspot-mailgun, PR 9, task 9.1/9.2/9.3).
 * Same shape as `listSegments`'s items (`AdminSegmentSummary`) — the backend reuses the
 * existing summary DTO for this bounded read, unlike templates (which needed a narrower DTO
 * to exclude `rutaBlob`). Fetched once per editor mount, never per keystroke.
 */
export function getSegmentOptions(): Promise<AdminSegmentSummary[]> {
  return apiFetch<AdminSegmentSummary[]>("/panel/segment-options");
}

/** `POST admin/segments` (role Operador, panel-segment-crud). 201 on success; 400 invalid nombre/nivelJerarquico/industria. */
export function createSegment(body: AdminSegmentWriteRequest): Promise<AdminSegmentSummary> {
  return apiFetch<AdminSegmentSummary>("/panel/segments", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

/** `PUT admin/segments/{id}` (role Operador, panel-segment-crud). 200 on success; 404 if the segment does not exist (or belongs to another tenant, non-disclosing-tenant). */
export function updateSegment(id: string, body: AdminSegmentWriteRequest): Promise<AdminSegmentSummary> {
  return apiFetch<AdminSegmentSummary>(`/panel/segments/${id}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });
}

/** `POST admin/segments/{id}/contacts` (role Operador). */
export function addContactsToSegment(segmentId: string, contactIds: string[]): Promise<AddSegmentContactsResult> {
  return apiFetch<AddSegmentContactsResult>(`/panel/segments/${segmentId}/contacts`, {
    method: "POST",
    body: JSON.stringify({ contactIds }),
  });
}
